import { render, staticRenderFns } from "./EditableAvatar.vue?vue&type=template&id=ad247864&lang=pug&"
import script from "./EditableAvatar.vue?vue&type=script&lang=js&"
export * from "./EditableAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EditableAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports